module.exports = __webpack_public_path__ + "img/settings6.485835cd.png";